import { ChatWidgetElement } from "./chat-widget";

export { ChatWidgetElement };
export type {
  ChatWidgetConfig,
  ThemeMode,
  WidgetPosition,
  WidgetMessage,
} from "./types";

if (!customElements.get("chat-widget")) {
  customElements.define("chat-widget", ChatWidgetElement);
}
